import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { ButtonWithIndicatorModule } from '../button-with-indicator/button-with-indicator.module';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { SocialsService } from '../socials/socials.service';
import { SocialsGridComponent } from './socials-grid/socials-grid.component';
import { SocialIconPipe } from './social-icon.pipe';
import { SocialFormModule } from './components/social-form/social-form.module';
import { DxValidationSummaryModule } from 'devextreme-angular';
import { SocialNameFromUrlPipe } from './social-name-from-url.pipe';

@NgModule({
  imports: [
    SharedModule,
    ModalWindowModule,
    ButtonWithIndicatorModule,
    SocialFormModule,
    DxValidationSummaryModule,
  ],
  declarations: [SocialsGridComponent, SocialIconPipe, SocialNameFromUrlPipe],
  exports: [SocialsGridComponent, SocialIconPipe],
  providers: [SocialsService, SocialIconPipe, SocialNameFromUrlPipe],
})
export class SocialsModule {}
